import { render } from "./ReviewEntryElement.vue?vue&type=template&id=8033d48a&scoped=true&ts=true"
import script from "./ReviewEntryElement.vue?vue&type=script&lang=ts"
export * from "./ReviewEntryElement.vue?vue&type=script&lang=ts"

import "./ReviewEntryElement.vue?vue&type=style&index=0&id=8033d48a&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8033d48a"]])

export default __exports__